/* template */
<template><div><div v-for="(item, index) in (list)" :key="item.name" :class='("item "+(list.length - 1 === index && !showFooterBtn ? "no-border" : ""))' :style="[(itemStyle)] | transRpxStyle" class="list"><div class="item-header"><div class="item-name">{{item.name}}</div><div><span class="item-distance">{{item.distance_desc}}</span><mpx-view @tap="toGuide(item)" class="item-guide" v-if="(canGuide)"><mpx-image src="https://ut-static.udache.com/webx/ut/V7wGh8vQW81jACg4d9Ngv.png" class="icon-guide"/>导航</mpx-view></div></div><div class="item-desc">{{item.detail_name}}</div><div :style="[(priceLabelStyle)] | transRpxStyle" class="item-price"><div class="price-vip"><span class="label">优惠价格:</span><span :style="[(priceStyle)] | transRpxStyle" class="value"><span class="unit">¥</span>{{item.vip_price}}</span></div><div class="price-original"><span class="label">油站价格:</span><span class="value"><span class="unit">¥</span>{{item.original_price}}</span></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m91bed5aa"}'>
@font-face {
  font-family: 'UniSansHeavyItalicCAPS';
  src: url('https://img-hxy021.didistatic.com/static/utfe/do1_l1Sw5zCiLssbdzlZQI12');
}
.item
  padding 48rpx 0 52rpx 0
  border-bottom: 1px dashed #C63200;
  &.no-border
    border-bottom none
  .item-header
    display flex
    margin-bottom 10rpx
    .item-name
      flex 1
    .item-name, .item-distance
      height: 48rpx;
      font-family: PingFangSC-Regular;
      font-size: 34rpx;
      color: #1B1B1B;
      font-weight: 400;
    .item-distance, .item-guide
      display inline-block
    .item-guide
      font-family: PingFangSC-Regular;
      font-size: 26rpx;
      color: #000000;
      padding-left 18rpx
      .icon-guide
        position relative
        top 2rpx
        right 2rpx
        width 26rpx
        height 26rpx
  .item-desc
    width: 423rpx;
    height: 30rpx;
    font-family: PingFangSC-Regular;
    font-size: 22rpx;
    color: #4E4E4E;
    font-weight: 400;
  .item-price
    display flex
    align-items: baseline;
    margin-top 32rpx
    color: #B6631D;
    .label
      font-family: PingFangSC-Medium;
      font-weight: 500
      font-size: 22rpx;

    .price-vip > .value
      font-family: UniSansHeavyItalicCAPS;
      font-weight: 400
      font-size: 60rpx;
      color: #E02D18;
      letter-spacing: 0;
      line-height: 60rpx;
      position relative
      bottom -4rpx
      .unit
        padding-right 8rpx
        font-size: 40rpx;
    .price-original
      padding-left 23rpx
      .value
        font-family: PingFangSC-Medium;
        font-weight: 500
        font-size: 22rpx;
      .unit
        padding-right 6rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m91bed5aa"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./gas-list.mpx.js?isComponent&outputPath=components%2Fgas-list91bed5aa%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../../webpack-config-fin/lib/business/webp-loader.js!./gas-list.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fgas-list91bed5aa%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m91bed5aa"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/gas-list91bed5aa/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
